// @flow
import React, { Component } from 'react'
import { StyledContent } from '../../styles/mixins'
import { Row, Col } from 'antd'
import CalculatorVolatility from '../form-calculator-volatility'
import CalculatorGreeks from '../form-calculator-greeks'

class CalculatorsView extends Component<{}> {
  render() {
    return (
      <StyledContent>
        <Row gutter={16}>
          <Col span={12}>
            <CalculatorGreeks />
          </Col>
          <Col span={12}>
            <CalculatorVolatility />
          </Col>
        </Row>
      </StyledContent>
    )
  }
}

export default CalculatorsView



// WEBPACK FOOTER //
// ./src/components/view-calculators/index.js